"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.AddressTypeEnum = exports.PlacementStatus = exports.CommissionPaymentStatus = exports.BalanceType = exports.CurrencyCodeEnum = exports.PaymentMethodType = exports.CountryEnum = exports.CommissionPaymentFrequency = exports.AssociateStatus = exports.AssociateAction = void 0;
var AssociateAction;
(function (AssociateAction) {
    AssociateAction["CREATED"] = "CREATED";
    AssociateAction["COMPENSATION_PLAN_CHANGE"] = "COMPENSATION_PLAN_CHANGE";
    AssociateAction["EFFECTIVE_DATE_CHANGE"] = "EFFECTIVE_DATE_CHANGE";
    AssociateAction["STATUS_CHANGE"] = "STATUS_CHANGE";
    AssociateAction["LEVEL_CHANGE"] = "LEVEL_CHANGE";
    AssociateAction["UPLINE_CHANGE"] = "UPLINE_CHANGE";
    AssociateAction["SPONSOR_CHANGE"] = "SPONSOR_CHANGE";
    AssociateAction["B2BGEMCHANGE"] = "B2B_GEM_CHANGE";
    AssociateAction["LEDGER_CHANGE"] = "LEDGER_CHANGE";
    AssociateAction["COMMISSION_PAYMENT_STATUS_CHANGE"] = "COMMISSION_PAYMENT_STATUS_CHANGE";
    AssociateAction["SUBAGENT_ADDED"] = "SUBAGENT_ADDED";
    AssociateAction["SUBAGENT_REMOVED"] = "SUBAGENT_REMOVED";
    AssociateAction["TAX_ID_ADDED"] = "TAX_ID_ADDED";
    AssociateAction["TAX_ID_REMOVED"] = "TAX_ID_REMOVED";
    AssociateAction["COMMISSION_PREFERENCES_CHANGES"] = "COMMISSION_PREFERENCES_CHANGES";
    AssociateAction["ADDRESS_ADDED"] = "ADDRESS_ADDED";
    AssociateAction["ADDRESS_UPDATED"] = "ADDRESS_UPDATED";
    AssociateAction["OWNER_CHANGED"] = "OWNER_CHANGED";
    AssociateAction["DELETED"] = "DELETED";
    AssociateAction["EXECUTIVE_DIRECTOR_CHANGED"] = "EXECUTIVE_DIRECTOR_CHANGED";
    AssociateAction["SENIOR_DIRECTOR_CHANGED"] = "SENIOR_DIRECTOR_CHANGED";
    AssociateAction["ENTITLEMENT_CHANGED"] = "ENTITLEMENT_CHANGED";
    AssociateAction["PLACEMENT_STATUS_CHANGED"] = "PLACEMENT_STATUS_CHANGED";
    AssociateAction["BROKER_QUALIFIED_CHANGED"] = "BROKER_QUALIFIED_CHANGED";
})(AssociateAction = exports.AssociateAction || (exports.AssociateAction = {}));
var AssociateStatus;
(function (AssociateStatus) {
    AssociateStatus["ACTIVE"] = "ACTIVE";
    AssociateStatus["NEEDS_REVIEW"] = "NEEDS_REVIEW";
    AssociateStatus["SUSPENDED"] = "SUSPENDED";
    AssociateStatus["CANCELLED"] = "CANCELLED";
})(AssociateStatus = exports.AssociateStatus || (exports.AssociateStatus = {}));
var CommissionPaymentFrequency;
(function (CommissionPaymentFrequency) {
    CommissionPaymentFrequency["DAILY"] = "DAILY";
    CommissionPaymentFrequency["WEEKLY"] = "WEEKLY";
    CommissionPaymentFrequency["MONTHLY"] = "MONTHLY";
})(CommissionPaymentFrequency = exports.CommissionPaymentFrequency || (exports.CommissionPaymentFrequency = {}));
var CountryEnum;
(function (CountryEnum) {
    CountryEnum["CAN"] = "CAN";
    CountryEnum["USA"] = "USA";
})(CountryEnum = exports.CountryEnum || (exports.CountryEnum = {}));
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["CHECK"] = "CHECK";
    PaymentMethodType["DIRECT_DEPOSIT"] = "DIRECT_DEPOSIT";
})(PaymentMethodType = exports.PaymentMethodType || (exports.PaymentMethodType = {}));
var CurrencyCodeEnum;
(function (CurrencyCodeEnum) {
    CurrencyCodeEnum["USD"] = "USD";
    CurrencyCodeEnum["CAD"] = "CAD";
    CurrencyCodeEnum["MXN"] = "MXN";
    CurrencyCodeEnum["GBP"] = "GBP";
})(CurrencyCodeEnum = exports.CurrencyCodeEnum || (exports.CurrencyCodeEnum = {}));
var BalanceType;
(function (BalanceType) {
    BalanceType["CREDIT"] = "CREDIT";
    BalanceType["DEBIT"] = "DEBIT";
    BalanceType["RESERVE"] = "RESERVE";
})(BalanceType = exports.BalanceType || (exports.BalanceType = {}));
var CommissionPaymentStatus;
(function (CommissionPaymentStatus) {
    CommissionPaymentStatus["NORMAL"] = "NORMAL";
    CommissionPaymentStatus["HELD_FOR_IRS"] = "HELD_FOR_IRS";
    CommissionPaymentStatus["HELD_BY_ASSOCIATE"] = "HELD_BY_ASSOCIATE";
    CommissionPaymentStatus["HELD_FOR_COMPLAINT"] = "HELD_FOR_COMPLAINT";
    CommissionPaymentStatus["HELD_FOR_DECEASED"] = "HELD_FOR_DECEASED";
    CommissionPaymentStatus["HELD"] = "HELD";
})(CommissionPaymentStatus = exports.CommissionPaymentStatus || (exports.CommissionPaymentStatus = {}));
var PlacementStatus;
(function (PlacementStatus) {
    PlacementStatus["AUTOMATIC"] = "AUTOMATIC";
    PlacementStatus["MANUAL"] = "MANUAL";
})(PlacementStatus = exports.PlacementStatus || (exports.PlacementStatus = {}));
var AddressTypeEnum;
(function (AddressTypeEnum) {
    AddressTypeEnum["MAILING"] = "MAILING";
})(AddressTypeEnum = exports.AddressTypeEnum || (exports.AddressTypeEnum = {}));
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://associates.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Associates API
 * @version v1
 * @baseUrl https://associates.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags AssociateAgreements
             * @name AssociateAgreementsAddAddress
             * @request POST:/v1/identities/{identityId}/associateAgreements/{associateId}/addAddress
             * @secure
             */
            associateAgreementsAddAddress: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associateAgreements/${associateId}/addAddress`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AssociateAgreements
             * @name AssociateAgreementsUpdateAddress
             * @request POST:/v1/identities/{identityId}/associateAgreements/{associateId}/updateAddress
             * @secure
             */
            associateAgreementsUpdateAddress: (identityId, associateId, data, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associateAgreements/${associateId}/updateAddress`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AssociateAgreements
             * @name AssociateAgreementsChangeOwner
             * @request POST:/v1/associateAgreements/{associateAgreementId}/changeOwner
             * @secure
             */
            associateAgreementsChangeOwner: (associateAgreementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/associateAgreements/${associateAgreementId}/changeOwner`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AssociateAgreements
             * @name AssociateAgreementsChangeExecutiveDirector
             * @request POST:/v1/identities/{identityId}/associateAgreements/{associateAgreementId}/changeExecutiveDirector
             * @secure
             */
            associateAgreementsChangeExecutiveDirector: (identityId, associateAgreementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associateAgreements/${associateAgreementId}/changeExecutiveDirector`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AssociateAgreements
             * @name AssociateAgreementsChangeSeniorDirector
             * @request POST:/v1/identities/{identityId}/associateAgreements/{associateAgreementId}/changeSeniorDirector
             * @secure
             */
            associateAgreementsChangeSeniorDirector: (identityId, associateAgreementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associateAgreements/${associateAgreementId}/changeSeniorDirector`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AssociateAgreements
             * @name AssociateAgreementsChangeEntitlement
             * @request POST:/v1/identities/{identityId}/associateAgreements/{associateAgreementId}/changeEntitlement
             * @secure
             */
            associateAgreementsChangeEntitlement: (identityId, associateAgreementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associateAgreements/${associateAgreementId}/changeEntitlement`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AssociateAgreements
             * @name AssociateAgreementsChangePlacementStatus
             * @request POST:/v1/identities/{identityId}/associateAgreements/{associateAgreementId}/changePlacementStatus
             * @secure
             */
            associateAgreementsChangePlacementStatus: (identityId, associateAgreementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associateAgreements/${associateAgreementId}/changePlacementStatus`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AssociateAgreements
             * @name AssociateAgreementsChangeBrokerQualified
             * @request POST:/v1/identities/{identityId}/associateAgreements/{associateId}/changeBrokerQualified
             * @secure
             */
            associateAgreementsChangeBrokerQualified: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associateAgreements/${associateId}/changeBrokerQualified`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesGetAssociate
             * @request GET:/v1/identities/{identityId}/associates/{associateId}
             * @secure
             */
            associatesGetAssociate: (identityId, associateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesGetAssociate2
             * @request GET:/v1/associates/{associateId}
             * @secure
             */
            associatesGetAssociate2: (associateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/associates/${associateId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesDeleteAssociate
             * @request DELETE:/v1/associates/{associateId}
             * @secure
             */
            associatesDeleteAssociate: (associateId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/associates/${associateId}`, method: 'DELETE', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesGetAssociates
             * @request GET:/v1/identities/{identityId}/associates
             * @secure
             */
            associatesGetAssociates: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesCreateAssociate
             * @request POST:/v1/identities/{identityId}/associates
             * @secure
             */
            associatesCreateAssociate: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesChangeCompensationPlan
             * @request POST:/v1/identities/{identityId}/associates/{associateId}/changeCompensationPlan
             * @secure
             */
            associatesChangeCompensationPlan: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/changeCompensationPlan`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesChangeEffectiveDate
             * @request POST:/v1/identities/{identityId}/associates/{associateId}/changeEffectiveDate
             * @secure
             */
            associatesChangeEffectiveDate: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/changeEffectiveDate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesChangeStatus
             * @request POST:/v1/identities/{identityId}/associates/{associateId}/changeStatus
             * @secure
             */
            associatesChangeStatus: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/changeStatus`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesChangeLevel
             * @request POST:/v1/identities/{identityId}/associates/{associateId}/changeLevel
             * @secure
             */
            associatesChangeLevel: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/changeLevel`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesChangeUpline
             * @request POST:/v1/identities/{identityId}/associates/{associateId}/changeUpline
             * @secure
             */
            associatesChangeUpline: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/changeUpline`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesChangeSponsor
             * @request POST:/v1/identities/{identityId}/associates/{associateId}/changeSponsor
             * @secure
             */
            associatesChangeSponsor: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/changeSponsor`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesChangeLedger
             * @request POST:/v1/identities/{identityId}/associates/{associateId}/changeLedger
             * @secure
             */
            associatesChangeLedger: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/changeLedger`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesChangeCommissionPaymentStatus
             * @request POST:/v1/identities/{identityId}/associates/{associateId}/changeCommissionPaymentStatus
             * @secure
             */
            associatesChangeCommissionPaymentStatus: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/changeCommissionPaymentStatus`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesChangeCommissionPreferences
             * @request POST:/v1/identities/{identityId}/associates/{associateId}/changeCommissionPreferences
             * @secure
             */
            associatesChangeCommissionPreferences: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/changeCommissionPreferences`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesAddSubAgent
             * @request POST:/v1/identities/{identityId}/associates/{associateId}/subAgents
             * @secure
             */
            associatesAddSubAgent: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/subAgents`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesRemoveSubAgent
             * @request DELETE:/v1/identities/{identityId}/associates/{associateId}/subAgents
             * @secure
             */
            associatesRemoveSubAgent: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/subAgents`, method: 'DELETE', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesAddTaxId
             * @request POST:/v1/identities/{identityId}/associates/{associateId}/taxIds
             * @secure
             */
            associatesAddTaxId: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/taxIds`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Associates
             * @name AssociatesRemoveTaxId
             * @request DELETE:/v1/identities/{identityId}/associates/{associateId}/taxIds
             * @secure
             */
            associatesRemoveTaxId: (identityId, associateId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/associates/${associateId}/taxIds`, method: 'DELETE', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AssociatesJournal
             * @name AssociatesJournalGetJournalChanges
             * @request GET:/v1/associates/journal
             * @secure
             */
            associatesJournalGetJournalChanges: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/associates/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AssociatesJournal
             * @name AssociatesJournalGetJournalMaxClock
             * @request GET:/v1/associates/journal/maxClock
             * @secure
             */
            associatesJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/associates/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;
//# sourceMappingURL=associates.js.map